import debug from "debug"
// To enable logging in browser: `localStorage.debug = "va"`
export const log = debug("va")
